import React from 'react';
import {
    HomeOutlined,
    SearchOutlined,
    UserOutlined,
    SettingOutlined
} from '@ant-design/icons';

/**
 * UIMobileNav - Mobile Navigation organism (bottom tab bar)
 */
const UIMobileNav = ({
    items = [
        { icon: 'home', label: 'Home', active: true },
        { icon: 'search', label: 'Search', active: false },
        { icon: 'user', label: 'Profile', active: false },
        { icon: 'settings', label: 'Settings', active: false }
    ],
    state = 'default',
    deviceType = 'mobile',
    tokens
}) => {
    const primaryColor = tokens?.colors?.find(c => c.name === 'primary')?.value || '#1677ff';

    // Get typography from tokens
    const captionTypo = tokens?.typography?.find(t => t.name === 'caption')
        || tokens?.typography?.find(t => t.name === 'body')
        || { fontFamily: 'Inter, system-ui, sans-serif', weight: 400, sizes: { mobile: 10, tablet: 11, desktop: 12 } };

    const captionSize = captionTypo.sizes?.[deviceType] || captionTypo.sizes?.mobile || 10;
    const baseFontFamily = captionTypo.fontFamily || 'Inter, system-ui, sans-serif';

    const ICON_MAP = {
        home: HomeOutlined,
        search: SearchOutlined,
        user: UserOutlined,
        settings: SettingOutlined
    };

    if (state === 'loading') {
        return (
            <div style={{
                width: '100%',
                height: '100%',
                background: '#161b22',
                borderTop: '1px solid #30363d',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <div style={{
                    width: 20,
                    height: 20,
                    border: '2px solid #30363d',
                    borderTopColor: primaryColor,
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                }} />
            </div>
        );
    }

    return (
        <div style={{
            width: '100%',
            height: '100%',
            background: '#161b22',
            borderTop: '1px solid #30363d',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around',
            padding: '0 8px',
            fontFamily: baseFontFamily
        }}>
            {items.map((item, index) => {
                const IconComponent = ICON_MAP[item.icon] || HomeOutlined;
                return (
                    <div
                        key={index}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 4,
                            padding: '8px 12px',
                            borderRadius: 8,
                            background: item.active ? 'rgba(22, 119, 255, 0.1)' : 'transparent'
                        }}
                    >
                        <IconComponent style={{
                            fontSize: 20,
                            color: item.active ? primaryColor : '#8b949e'
                        }} />
                        <span style={{
                            fontSize: captionSize,
                            fontWeight: captionTypo.weight || 400,
                            color: item.active ? primaryColor : '#8b949e'
                        }}>
                            {item.label}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

export default UIMobileNav;
